import { MessageType, MessageStatus } from '@gig/magic-sdk/dist/adapter/messages/message';

function isHidden(message) {
  if (isResponsibleGamingAlert(message)) {
    return false;
  }
  if (message.once && message.status === MessageStatus.DELETED) {
    return true;
  }
  {
    return new Date().valueOf() - new Date(message.sentAt).valueOf() > 1728e5;
  }
}
function isResponsibleGamingAlert(message) {
  return message.type === MessageType.ALERTS;
}

export { isHidden, isResponsibleGamingAlert };
